import { defineComponent } from 'navigation-components/platform/models';
import { CHATSPOT_SIDEBAR_COMPONENT, Tags } from '../constants';
import { getIframeSrc, getStyle } from './internal';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
const COPILOT_SIDEBAR_CLASS = '.copilot-sidebar-container';
const QUARTZ_SIDEBAR_CLASS = '.quartz-grid-sidebar-container';
const COPILOT_THREAD_ID_QUERY_PARAM = 'copilotThreadId';
const COPILOT_PROMPT_QUERY_PARAM = 'copilotPrompt';
function getCopilotThreadIdParam() {
  const urlQueryParams = new URLSearchParams(window.location.search);
  return urlQueryParams.get(COPILOT_THREAD_ID_QUERY_PARAM) || '';
}
function getCopilotPromptParam() {
  const urlQueryParams = new URLSearchParams(window.location.search);
  return urlQueryParams.get(COPILOT_PROMPT_QUERY_PARAM) || '';
}
const getShouldStartOpen = () => {
  try {
    const copilotInitialOpenSessionStorageValue = sessionStorage.getItem('copilot-initialize-open');
    // 0 = closed | 1 = open | 2 = open expanded view
    return copilotInitialOpenSessionStorageValue === '1' || copilotInitialOpenSessionStorageValue === '2' ||
    // TODO - @mlegocki: remove this line once we've merged in other related PRs to avoid regressions
    // PR: https://git.hubteam.com/HubSpot/chatspot-ui/pull/2483
    copilotInitialOpenSessionStorageValue === 'true';
  } catch (e) {
    return false;
  }
};
export const chatspotSidebarComponentDef = defineComponent(CHATSPOT_SIDEBAR_COMPONENT, () => {
  const copilotSidebar = document.querySelector(COPILOT_SIDEBAR_CLASS) || document.querySelector(QUARTZ_SIDEBAR_CLASS);
  return {
    name: CHATSPOT_SIDEBAR_COMPONENT,
    src: getIframeSrc(),
    capabilities: [capabilities.UPSERT_GLOBAL_STYLES_CAP.getName(), capabilities.RESTYLE_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.UPDATE_QUERY_PARAM_CAP.getName()],
    deferLoading: false,
    initiallyOpen: getShouldStartOpen(),
    propsSchema: {
      isSearchOpen: args.optional(args.bool()),
      threadIdQueryParam: args.optional(args.string())
    },
    iframeProps: {
      style: getStyle()
    },
    initialProps: {
      isSearchOpen: false,
      threadIdQueryParam: getCopilotThreadIdParam(),
      copilotPromptQueryParam: getCopilotPromptParam()
    },
    renderTo: () => copilotSidebar,
    tags: [Tags.SIDE_PANEL]
  };
});